import React, { PropsWithChildren } from 'react';
import cn from 'clsx';

import styles from './content.scss';

interface ContentProps {
  className?: string;
  id?: string;
  isFullWidth?: boolean;
  showFrame?: boolean;
}

function Content(props: PropsWithChildren<ContentProps>) {
  const {
    children,
    className,
    id,
    isFullWidth = false,
    showFrame = false
  } = props;

  return (
    <div
      className={cn(
        isFullWidth && styles['full-width'],
        showFrame ? styles['content-frame'] : styles['content'],
        className
      )}
      data-testid="page-content"
      id={id}
    >
      {children}
    </div>
  );
}

export default Content;
